import * as React from "react";
import { forwardRef } from "react";
const SvgReset = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 16, height: 16, viewBox: "0 0 16 16", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M14 7.98107C14 10.7503 11.6923 13.9811 8 13.9811C4.30769 13.9811 2 10.7503 2 7.98107C2 5.21184 4.30769 1.98107 8 1.98107C10.3077 1.98107 12.1538 3.36569 13.0769 4.7503M13.0769 4.7503L9.84615 5.21184M13.0769 4.7503L13.5385 1.51953", stroke: "#1A2023", strokeLinecap: "round", strokeLinejoin: "round" }));
const ForwardRef = forwardRef(SvgReset);
export { ForwardRef as ReactComponent };
